import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../index'
import Button from '../../Button'
import {CloseConversationModalViewProps} from './types'
import Modal from '../Modal'
import {ModalFooterLeft} from '../ModalView'
import React from 'react'
import {useTranslation} from 'react-i18next'

const CloseConversationModalView = ({
    onClose,
    onCancel,
}:CloseConversationModalViewProps): React.ReactElement => {
    const {t} = useTranslation()
    return (
        <Modal onClose={onCancel}>
            <ModalHeader title={t('Do you wish to close the conversation?')} />
            <ModalContent>
                <div>{t('Conversation will be closed and you cannot add tags or notes anymore')}</div>
            </ModalContent>
            <ModalFooter>
                <ModalFooterLeft>
                    <Button onPress={onCancel} tabIndex={-1} text={t('Cancel')} />
                </ModalFooterLeft>
                <Button color='filled' onPress={onClose} tabIndex={0} text={t('Close')} />
            </ModalFooter>
        </Modal>
    )
}

export default CloseConversationModalView
